export interface LocationNameEntry {
  de?: string;
  fr?: string;
  it?: string;
  nl?: string;
  hr?: string;
  pl?: string;
}

export const LOCATION_NAME_TRANSLATIONS: Record<string, LocationNameEntry> = {
  "Plitvice Lakes": {
    hr: "Plitvička Jezera",
    de: "Plitvicer Seen",
    fr: "Lacs de Plitvice",
    it: "Laghi di Plitvice",
    nl: "Plitvicemeren",
    pl: "Jeziora Plitwickie",
  },
};

export function getLocalizedLocationName(name: string, lang: string): string {
  const entry = LOCATION_NAME_TRANSLATIONS[name];
  if (!entry) return name;
  return (entry as Record<string, string>)[lang] ?? name;
}
